import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { userBlockReason } from "@/lib/userStatus";

const LOGO = "/assets/logo-nostradamus-oficial.png?v=3";

const REASON_MESSAGES = {
  pending_approval: {
    title: "Aguardando aprovação",
    body: "Seu acesso ainda não foi liberado. Um administrador do Projeto Nostradamus precisa validar seu cadastro antes da liberação.",
  },
  rejected: {
    title: "Acesso negado",
    body: "Seu cadastro foi recusado pela administração. Procure um administrador do Projeto Nostradamus para mais informações.",
  },
  inactive: {
    title: "Conta inativa",
    body: "Sua conta está temporariamente inativa. Procure um administrador do Projeto Nostradamus para reativar o acesso.",
  },
  suspended: {
    title: "Conta suspensa",
    body: "Sua conta está suspensa. Procure um administrador do Projeto Nostradamus para regularização.",
  },
  blocked: {
    title: "Acesso indisponível",
    body: "Seu acesso ainda não foi liberado ou está temporariamente indisponível. Procure um administrador do Projeto Nostradamus.",
  },
};

export default function PendingApproval() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const reason = userBlockReason(user) || "blocked";
  const msg = REASON_MESSAGES[reason] || REASON_MESSAGES.blocked;

  const handleLogout = async () => {
    await logout();
    nav("/login");
  };

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="pending-approval-page">
      <div className="bg-[#0F1B2D] text-white text-[11px] py-1.5 px-6 uppercase tracking-wider font-mono">
        Marinha do Brasil · Escola de Guerra Naval · LSC
      </div>
      <main className="flex-1 flex items-center justify-center px-6 py-10">
        <div className="w-full max-w-lg bg-white border border-slate-200 rounded-lg shadow-sm overflow-hidden text-center">
          <div className="border-b border-slate-200 px-8 pt-10 pb-6 flex flex-col items-center">
            <img src={LOGO} alt="LSC/EGN" className="w-[120px] h-auto" />
            <h1 className="font-display font-bold text-2xl text-[#0F1B2D] mt-5">Projeto Nostradamus</h1>
            <p className="text-xs text-slate-500 mt-1 uppercase tracking-widest font-mono">LSC · EGN</p>
          </div>

          <div className="px-8 py-8 space-y-4">
            <div className="w-14 h-14 mx-auto rounded-full bg-[#C5A028]/10 border-2 border-[#C5A028] flex items-center justify-center text-[#C5A028] text-2xl" data-testid="pending-icon">
              ⌛
            </div>
            <h2 className="font-display font-bold text-xl text-[#0F1B2D]" data-testid="pending-title">{msg.title}</h2>
            <p className="text-sm text-slate-600 leading-relaxed" data-testid="pending-body">{msg.body}</p>
            {user && (
              <div className="bg-slate-50 border border-slate-200 rounded p-3 text-xs text-slate-600 font-mono inline-block">
                <div>{user.name}</div>
                <div>{user.email}</div>
                <div className="text-[10px] mt-1 text-slate-400 uppercase tracking-widest">
                  Status: {user.status || "—"}
                </div>
              </div>
            )}
            <div className="pt-2">
              <button
                onClick={handleLogout}
                className="text-xs text-slate-500 hover:text-[#0F1B2D] underline"
                data-testid="pending-logout"
              >
                Sair
              </button>
            </div>
          </div>

          <div className="bg-slate-50 border-t border-slate-200 px-6 py-3 text-[10px] uppercase tracking-widest text-slate-400 font-mono">
            Laboratório de Simulações e Cenários · Marinha do Brasil
          </div>
        </div>
      </main>
    </div>
  );
}
